module.exports = __webpack_public_path__ + "img/octicon_alert-24.84e1a305.svg";